import {
  RESET_EMAIL_SET_FOCUS,
  RESET_EMAIL_SET,
  RESET_EMAIL_SET_VALIDATION_MESSAGE,
  RESET_EMAIL_SET_VISUALIZATION,
  RESET_EMAIL_SET_API_ERROR
} from 'src/app/redux/actions/reset/resetEmail';


const initialState = {
  value: '',
  validationMessage: '',
  markedAsWrong: false,
  apiError: false,
  focus: false,
  disabled: false
};

const resetEmailReducer = (state = initialState, action = {}) => ({
  [RESET_EMAIL_SET_API_ERROR]: () => ({ ...state, apiError: action.payload }),
  [RESET_EMAIL_SET]: () => ({ ...state, value: action.payload }),
  [RESET_EMAIL_SET_FOCUS]: () => ({ ...state, focus: action.payload }),
  [RESET_EMAIL_SET_VALIDATION_MESSAGE]: () => ({ ...state, validationMessage: action.payload }),
  [RESET_EMAIL_SET_VISUALIZATION]: () => ({ ...state, markedAsWrong: action.payload })
}[action.type] || (() => state))();

export default resetEmailReducer;
